'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavMobileLinks = () => {
  const $ = _c(25);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    logInCta,
    signUpCta
  } = useTopNav();
  let t0;
  if ($[0] !== logInCta?.href || $[1] !== trackSelectNavCta) {
    t0 = () => {
      trackSelectNavCta({
        "cta url": logInCta?.href
      });
    };
    $[0] = logInCta?.href;
    $[1] = trackSelectNavCta;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = logInCta?.href ?? "";
  const t2 = logInCta?.newTab ? "noopener noreferrer" : "";
  const t3 = logInCta?.newTab ? "_blank" : "_self";
  const t4 = logInCta?.title;
  let t5;
  if ($[3] !== t4) {
    t5 = <Button className="w-full text-bodi-white" variant="secondary" size="medium">{t4}</Button>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <LocalizedLink onClick={t0} data-testid="logInBtn" href={t1} rel={t2} target={t3}>{t5}</LocalizedLink>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== signUpCta?.href || $[12] !== trackSelectNavCta) {
    t7 = () => {
      trackSelectNavCta({
        "cta url": signUpCta?.href
      });
    };
    $[11] = signUpCta?.href;
    $[12] = trackSelectNavCta;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = signUpCta?.href ?? "";
  const t9 = signUpCta?.newTab ? "noopener noreferrer" : "";
  const t10 = signUpCta?.newTab ? "_blank" : "_self";
  const t11 = signUpCta?.title;
  let t12;
  if ($[14] !== t11) {
    t12 = <Button className="w-full" variant="primary" size="medium">{t11}</Button>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t13 = <LocalizedLink onClick={t7} data-testid="signUpBtn" href={t8} rel={t9} target={t10}>{t12}</LocalizedLink>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t6) {
    t14 = <div className="fixed bottom-0 left-0 flex w-screen flex-col gap-3 border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5">{t6}{t13}</div>;
    $[22] = t13;
    $[23] = t6;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};